/**
 * NavMenu.js — список пунктов меню в sidebar.
 *
 * Структура сверху вниз:
 * 1. Основные разделы (Личный кабинет … Обновления)
 * 2. footer — слот для ReferralSidebarCard (рефералка)
 * 3. Нижние пункты (Поддержка, Выйти)
 *
 * footer передаёт NavBar, чтобы карточка жила между меню и «Поддержка».
 */

import { menuRouteList } from "../../routing/Routes";
import MenuItem from "./MenuItem";
import { BOTTOM_MENU_ITEMS_COUNT } from "./navBarConstants";

const NavMenu = ({ footer }) => {
  const mainItems = menuRouteList.slice(0, -BOTTOM_MENU_ITEMS_COUNT);
  const bottomItems = menuRouteList.slice(-BOTTOM_MENU_ITEMS_COUNT);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {mainItems.map((el, key) => (
        <div style={{ cursor: "pointer" }} key={key}>
          <MenuItem path={el.path} name={el.name} icon={el.icon} />
        </div>
      ))}

      {footer}

      {bottomItems.map((el, key) => (
        <div style={{ cursor: "pointer" }} key={`bottom-${key}`}>
          <MenuItem path={el.path} name={el.name} icon={el.icon} />
        </div>
      ))}
    </div>
  );
};

export default NavMenu;
